import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=49c61ebe"
import script from "./how-it-works.vue?vue&type=script&lang=js"
export * from "./how-it-works.vue?vue&type=script&lang=js"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=49c61ebe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports